import { ROUTES } from '@discover/utils/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceId/')({
  beforeLoad({ params }) {
    // Set home as our default route endpoint
    throw redirect({ to: ROUTES.home, params })
  },
})
